// Coffee recipe images from the internet
export const coffeeImages = {
  espresso: {
    url: "https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    alt: "Classic Espresso shot with rich crema",
    credit: "Photo by Unsplash"
  },
  latte: {
    url: "https://www.brighteyedbaker.com/wp-content/uploads/2024/07/Dulce-de-Leche-Latte-with-Whipped-Cream.jpg",
    alt: "Beautiful Dulce de Leche Latte with caramel drizzle and whipped cream",
    credit: "Photo from Bright Eyed Baker",
    fallback: "https://images.unsplash.com/photo-1561043433-9265f73e685f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
  },
  cappuccino: {
    url: "https://images.unsplash.com/photo-1572442388796-11668a67e53d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    alt: "Perfect Cappuccino with dense foam",
    credit: "Photo by Unsplash"
  },
  coldBrew: {
    url: "https://images.unsplash.com/photo-1461023058943-07fcbe16d735?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    alt: "Cold Brew coffee with ice",
    credit: "Photo by Unsplash"
  },
  pourOver: {
    url: "https://images.unsplash.com/photo-1447933601403-0c6688de566e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    alt: "Pour Over coffee brewing",
    credit: "Photo by Unsplash"
  },
  frenchPress: {
    url: "https://images.unsplash.com/photo-1511920170033-f8396924c348?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    alt: "French Press coffee",
    credit: "Photo by Unsplash"
  },
  mocha: {
    url: "https://images.unsplash.com/photo-1578314675249-a6910f80cc4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    alt: "Mocha coffee with chocolate",
    credit: "Photo by Unsplash"
  },
  americano: {
    url: "https://images.unsplash.com/photo-1509042239860-f550ce710b93?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    alt: "Americano coffee",
    credit: "Photo by Unsplash"
  }
};

// Fallback images in case the main images don't load
export const fallbackImages = {
  espresso: "https://images.unsplash.com/photo-1559056199-641a0ac8b55e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  latte: "https://images.unsplash.com/photo-1561043433-9265f73e685f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  cappuccino: "https://images.unsplash.com/photo-1572442388796-11668a67e53d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  coldBrew: "https://images.unsplash.com/photo-1461023058943-07fcbe16d735?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  pourOver: "https://images.unsplash.com/photo-1447933601403-0c6688de566e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  frenchPress: "https://images.unsplash.com/photo-1511920170033-f8396924c348?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  mocha: "https://images.unsplash.com/photo-1578314675249-a6910f80cc4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  americano: "https://images.unsplash.com/photo-1509042239860-f550ce710b93?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
};
